import { SIDEBAR_LINKS } from './index';

export function pageList(user) {
  const raw = user?.gestion_pages;
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }
  return null;
}

const MENU_URLS = [
  ...SIDEBAR_LINKS.map((link) => link.url),
  '/comptable',
  '/inventory',
  '/sales',
]
  .filter((url) => url !== '/')
  .sort((a, b) => b.length - a.length);

export function menuUrlForPath(pathname) {
  return MENU_URLS.find((url) => pathname === url || pathname.startsWith(`${url}/`)) || null;
}

export function isPageBlocked(user, pathname) {
  if (!user?.gestion_custom || user.role === 'superAdmin') return false;
  const pages = pageList(user);
  if (!pages) return false;
  if (pathname === '/' || pathname === '') return !pages.includes('/');
  const required = menuUrlForPath(pathname);
  if (!required) return false;
  return !pages.includes(required);
}
